/**
 * Returns the color associated with an account type
 * @param type The account type
 * @returns The color in hex format
 */
export const getAccountTypeColor = (type: string): string => {
  const colors: Record<string, string> = {
    bank: '#1E5591',
    investment: '#2E7D32',
    'real-estate': '#ED6C02',
    crypto: '#9C27B0',
    alternative: '#1976D2',
    liability: '#D32F2F',
  };
  return colors[type] || '#757575';
};
